import type { IconData } from '../../types';

export const data: IconData = {
  o: '<rect width="20" height="4" x="4" y="4" fill="none" stroke="currentColor" stroke-width="2" rx="1"/><rect width="20" height="4" x="4" y="12" fill="none" stroke="currentColor" stroke-width="2" rx="1"/><rect width="20" height="4" x="4" y="20" fill="none" stroke="currentColor" stroke-width="2" rx="1"/>',
  f: '<rect width="20" height="4" x="4" y="4" stroke="currentColor" rx="1"/><rect width="20" height="4" x="4" y="12" stroke="currentColor" rx="1"/><rect width="20" height="4" x="4" y="20" stroke="currentColor" rx="1"/>',
  vb: '0 0 28 28',
};

export default data;
